import React from 'react'

// LAZY-LOADED SCREENS START
const BusinessProfilePage = React.lazy(
  () => import('./screens/business-profile-page'),
)
const CreateProfilePage = React.lazy(
  () => import('./screens/create-profile-page'),
)
const StorefrontCartPage = React.lazy(
  () => import('./screens/storefront-cart-page'),
)
const StorefrontOrderConfirmationPage = React.lazy(
  () => import('./screens/storefront-order-confirmation-page'),
)
const ErrorPage = React.lazy(() => import('./screens/error-page'))
// LAZY-LOADED SCREENS END

export function getRoutes() {
  const routes = [
    {
      path: '/profile',
      element: <CreateProfilePage />,
    },
    {
      path: '/profile/:handle',
      element: <BusinessProfilePage />,
    },
    {
      path: '/profile/:handle/edit/*',
      element: <BusinessProfilePage />,
    },
    {
      path: '*',
      element: <ErrorPage reloadPage={false} />,
    },
    {
      path: '/profile/:handle/cart',
      element: <StorefrontCartPage />,
    },
    {
      path: '/profile/:handle/cart/failed',
      element: <ErrorPage orderCaptureFailed={true} reloadPage={false} />,
    },
    {
      path: '/profile/:handle/order-confirmation',
      element: <StorefrontOrderConfirmationPage />,
    },
  ]

  return routes
}
